import { useAuthQuery } from 'app/api_v2/auth/queries';
import { isBackoffice, isClient, isGeneral, isInspector } from 'app/helpers/userRoles';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface HasToBeAllowedForInspectionsGuardProps {
  children: React.ReactNode;
}

export const HasToBeAllowedForInspectionsGuard = (props: HasToBeAllowedForInspectionsGuardProps) => {
  const { children } = props;

  const { isSuccess, data } = useAuthQuery();

  if (isSuccess && !data) {
    return <Navigate to={'/auth/login'} />;
  }

  if (isSuccess && data && !isBackoffice(data) && !isClient(data) && !isInspector(data) && !isGeneral(data)) {
    return <Navigate to={'/dashboard'} />;
  }

  return <>{children}</>;
};

export default HasToBeAllowedForInspectionsGuard;
